import { type ButtonProps, cn, Button as UIButton } from '@mntn/ui-components'
import { cva } from 'class-variance-authority'
import { forwardRef } from 'react'

const flightDeckVariants = cva('', {
  variants: {
    variant: {
      active: 'bg-primary-accent text-header-inverse hover:bg-primary-accent/80',
      inactive: 'bg-sub-surface-bg-inverse text-primary-inverse hover:bg-secondary',
      secondary: 'bg-dark-bg text-header-inverse hover:bg-dark-bg/80 border-none font-normal shadow-md',
      screen:
        'bg-sub-screen-bg-inverse text-header-inverse border border-border-inverse hover:bg-sub-screen-bg-inverse/80',
    },
  },
})

const UI_VARIANTS = ['core', 'primary', 'error', 'tertiary', 'text', 'outline', 'ghost', 'bordered'] as const

type UIVariant = (typeof UI_VARIANTS)[number]
type FlightDeckVariant = 'active' | 'inactive' | 'secondary' | 'screen'

export interface FlightDeckButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: UIVariant | FlightDeckVariant
}

export const Button = forwardRef<HTMLButtonElement, FlightDeckButtonProps>(
  ({ variant = 'primary', className, ...props }, ref) => {
    // biome-ignore lint/nursery/noUnsafeTypeAssertion: RETIRED, do not copy. Fix the source type or narrow the value when touching this.
    if (UI_VARIANTS.includes(variant as UIVariant)) {
      return (
        <UIButton
          ref={ref}
          // biome-ignore lint/nursery/noUnsafeTypeAssertion: RETIRED, do not copy. Fix the source type or narrow the value when touching this.
          variant={variant as UIVariant}
          className={className}
          {...props}
        />
      )
    }

    return (
      <UIButton
        ref={ref}
        className={cn(
          // biome-ignore lint/nursery/noUnsafeTypeAssertion: RETIRED, do not copy. Fix the source type or narrow the value when touching this.
          flightDeckVariants({ variant: variant as FlightDeckVariant }),
          className,
        )}
        {...props}
      />
    )
  },
)

Button.displayName = 'FlightDeckButton'
